module.exports = __webpack_public_path__ + "static/media/thumbnailChopra.086b0cb5.png";